import { SecondaryButton } from 'components/Shared/Button'
import DropDown from 'components/Shared/DropDown'
import Input from 'components/Shared/Input'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataIntegrations } from './DataIntegrationsProvider'
import { localizeDateObj } from 'utils/helpers'
import ErrorMessage from 'components/Shared/ErrorMessage'

export default function AddIntegration() {
  const { t } = useTranslation()
  const { integrationTypes, loading, error, addIntegration } = useDataIntegrations()
  const [selectedIntegration, setSelectedIntegration] = useState({ type: '', secret: '', tenantRef: '' })

  const options = integrationTypes?.map((type) => ({
    value: type.type,
    text: type.display_name,
  })) || []

  const submitIntegration = async () => {
    const name = `${selectedIntegration.type}-${localizeDateObj(new Date(), 'de', 'DD.MM.YYYY.-HH:mm:ss')}`
    const result = await addIntegration({
      serviceName: selectedIntegration.type,
      name: name,
      rawSecret: selectedIntegration.secret,
      tenantRef: selectedIntegration.tenantRef || undefined,
    })
    if (result.success) {
      setSelectedIntegration({ type: '', secret: '', tenantRef: '' })
    }
  }

  const requiresTenantRef = !!integrationTypes?.find(
    (type) => type.type === selectedIntegration.type,
  )?.requires_tenant_ref

  return (
    <>
      <div className="integrations_add">
        <DropDown
          classNames="integrations_add__dropdown"
          options={options}
          placeholder={t('Integrations.manage.integration')}
          onChange={(t) => setSelectedIntegration((v) => ({ ...v, type: t }))}
          value={selectedIntegration.type}
          name="integrationType"
          disabled={!integrationTypes}
        />
        <Input
          value={selectedIntegration.secret}
          name="key"
          required
          placeholder={t('Integrations.manage.addApiKey')}
          separatePlaceholder
          onChange={(e) => setSelectedIntegration((si) => ({ ...si, secret: e.target.value }))}
          wrapperClass="integrations_add__input"
          disabled={!selectedIntegration.type}
        />
        {requiresTenantRef && (
          <Input
            value={selectedIntegration.tenantRef}
            name="tenant_ref"
            required
            placeholder={t('Integrations.manage.addTenantRef')}
            separatePlaceholder
            onChange={(e) => setSelectedIntegration((si) => ({ ...si, tenantRef: e.target.value }))}
            wrapperClass="integrations_add__input"
          />
        )}
        <SecondaryButton
          color="orange"
          text={t('common.save')}
          classNames="integrations_add__button"
          onClick={submitIntegration}
          fullWidth={false}
          disabled={!selectedIntegration.type || !selectedIntegration.secret || (requiresTenantRef && !selectedIntegration.tenantRef) || loading.add}
        />
      </div>
      {error.add && (
        <ErrorMessage classNames="mt-2" danger>
          {error.add}
        </ErrorMessage>
      )}
    </>
  )
}
